import template from "./quote-template-share-modal.html";

const QuoteTemplateShareModalComponent = {
  bindings: {
    resolve: "<",
    close: "&",
    dismiss: "&",
  },
  template: template,
  controller: class QuoteTemplateShareModalController {
    /* @ngInject */
    constructor($rootScope, $state, $filter) {
      this.$rootScope = $rootScope;
      this.$state = $state;
      this.$filter = $filter;
    }

    async $onInit() {
      this.shareByDefault = this.resolve.shareByDefault;
      this.quoteTemplate = this.resolve.quoteTemplate;
      this.quoteTemplateShared = this.quoteTemplate.isShared();
      this.quoteTemplateShareImportCode = this.quoteTemplate.isShared()
        ? this.quoteTemplate.shared.importCode
        : undefined;

      if (this.shareByDefault) {
        this.quoteTemplateShared = true;
        if (!this.quoteTemplate.isShared()) {
          await this.quoteTemplate.share(this.quoteTemplateShareImportCode);
          this.quoteTemplateShareImportCode = this.quoteTemplate.shared.importCode;
        } else {
          this.quoteTemplateShared = this.quoteTemplate.shared.isShared;
        }
        this.$rootScope.$applyAsync();
      }
    }

    async toogleShared() {
      if (this.quoteTemplateShared) {
        await this.quoteTemplate.share(this.quoteTemplateShareImportCode);
        this.quoteTemplateShareImportCode = this.quoteTemplate.shared.importCode;
      } else {
        await this.quoteTemplate.unshare();
        this.quoteTemplateShareImportCode = undefined;
      }
      this.$rootScope.$applyAsync();
    }

    close() {
      this.dismiss({ $value: "cancel" });
    }
  },
};

export default QuoteTemplateShareModalComponent;
